import { IsBoolean, IsIn, IsInt, IsNotEmpty, IsOptional, IsString, IsUUID } from 'class-validator';

import type { NomenclatureType } from '../nomenclature-type';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const NomenclatureTypeUpdateTypeErrorMessage = 'Значение «Вид учета» неверно.';

export class NomenclatureTypeUpdateRequest implements Partial<Omit<NomenclatureType, 'isSystem'>> {
    @IsOptional()
    @IsString()
    @IsUUID()
    public uuid?: string;

    @IsString()
    @IsNotEmpty()
    public name: string;

    @IsInt()
    @IsIn([1, 2, 3], { message: NomenclatureTypeUpdateTypeErrorMessage })
    public type: number;

    @IsOptional()
    @IsBoolean()
    public isFranchise?: boolean;

    @IsOptional()
    @IsString()
    public priceFormula?: string;

    @IsOptional()
    @IsString()
    public quantityFormula?: string;

    constructor(data?: Partial<NomenclatureTypeUpdateRequest>) {
        const uuid = data?.uuid;
        this.uuid = typeof uuid === 'string' && uuid.trim() ? uuid : undefined;
        this.name = data?.name;
        this.type = data?.type;
        this.isFranchise = data?.isFranchise;
        this.priceFormula = data?.priceFormula ?? null;
        this.quantityFormula = data?.quantityFormula ?? null;
    }
}
